import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsSignupTermsModal = (props: { active: boolean, closeHandler: any }) => {
    const [terms, setTerms] = useState('');
    const [termsErr, setTermsErr] = useState(false);
    const termsId = useId();
    const getTerms = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/presignup/terms/get',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                terms: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setTerms(d.terms);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            getTerms();
            setTermsErr(false);
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const t = terms.trim();
        if (t.length < 3) {
            setTermsErr(true);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/presignup/terms/set',
            {
                terms: t,
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                props.closeHandler();
                ShowSnackbar(
                    'تغییرات ذخیره شد.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div><b>ویرایش قوانین ثبت‌نام</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label htmlFor={termsId}>قوانین و مقررات ثبت‌نام جهت تایید توسط والدین:</label>
                        <textarea id={termsId}
                                  className={"form-control" + (termsErr ? ' is-invalid' : '')}
                                  value={terms}
                                  onChange={e => {
                                      setTerms(e.currentTarget.value);
                                      setTermsErr(false);
                                  }}
                                  style={{minHeight: 200, maxHeight: 500}}
                        />
                        <div className={"invalid-feedback" + (termsErr ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۳ کاراکتر وارد نمایید.
                        </div>
                        <div className="d-flex justify-content-end align-items-center" style={{marginTop: 20, gap: 5}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره متن</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};